import { RotaryErrorFragment } from "@saleor/fragments/types/RotaryErrorFragment";
import { RotaryErrorCode } from "@saleor/types/globalTypes";
import { defineMessages, IntlShape } from "react-intl";

const messages = defineMessages({
  rotaryItemAlreadyExists: {
    defaultMessage: "该名称在本ROTARY已存在"
  },
  rotaryItemNotNull: {
    defaultMessage: "该字段为必填项，不能为空"
  },
  unique: {
    defaultMessage: "Items的概率总和大于100%，请重新配置Items"
  }
});

export function getRotaryItemErrorMessage(
  err: RotaryErrorFragment,
  intl: IntlShape
): string {
  switch (err?.code) {
    case RotaryErrorCode.ALREADY_EXISTS:
      return intl.formatMessage(messages.rotaryItemAlreadyExists);
    case RotaryErrorCode.NOT_FOUND:
      return intl.formatMessage(messages.rotaryItemNotNull);
    case RotaryErrorCode.UNIQUE:
      return intl.formatMessage(messages.unique);
    default:
      return "";
  }
}
